<script setup lang="tsx">
import { computed } from 'vue'
import HeaderComponent from '../shared/HeaderComponent.vue'
import IconButton from '../shared/IconButton.vue'
import { PermAllDataAssetWrite, PermDataAssetAdd, PermOwnDataAssetWrite } from '@/models/enums-generated'
import sliderStore from '@/stores/slider'
import DataAssetTable from './DataAssetTable.vue'
import ExportBtn from '../widgets/ExportBtn.vue'
import { hasPermission } from '@/services/utils'
import { dataAssetRefreshCallback } from '../business_processes/shared'

const slider = sliderStore()
const canAdd = computed(() => hasPermission(PermDataAssetAdd))
const canImport = computed(() => canAdd.value || hasPermission(PermAllDataAssetWrite) || hasPermission(PermOwnDataAssetWrite))
</script>

<template>
	<HeaderComponent :title="$t('dataAsset')">
		<template #right-side>
			<div class="d-flex align-items-center gap-2">
				<ExportBtn entity="data_asset" :can-import="canImport" @imported="dataAssetRefreshCallback?.forEach((fn) => fn())"></ExportBtn>
				<IconButton
					v-if="canAdd"
					data-test="open-new-data-asset"
					:title="$t('misc.add')"
					class="bi bi-plus-square"
					@click="slider.openDataAsset"
				>
				</IconButton>
			</div>
		</template>
	</HeaderComponent>
	<DataAssetTable></DataAssetTable>
</template>
